import InputDate from "../../../../parts/InputDate";
import InputText from "../../../../parts/InputText";
import Option from '../../../../../interfaces/Option';
import { FormEvent, useRef, useState } from "react";
import RequiredMark from "../../../../parts/RequiredMark";
import ErrorMessage from "../../../../parts/ErrorMessage";
import ButtonSubmit from "../../../../parts/ButtonSubmit";
import { useLocation, useNavigate } from "react-router-dom";
import InputRef from "../../../../../interfaces/InputRef";
import InputCheckbox from "../../../../parts/InputCheckbox";
import { ActiveScoutCensusSummaryForm } from "./ActiveScoutCensusSummaryForm";
import {Heading, Link} from "@chakra-ui/react"
import InputRadioButton from "../../../../parts/InputRadioButton";
import MultiFunctionRef from "../../../../../interfaces/MultiFunctionRef";
import MultiFunctionForm from "../../../../parts/FunctionAssignment";
import { Census } from "../../../../../model/census";

interface ActiveScoutCensusProps {
    census: Census | undefined;
}

export function ActiveScoutCensus(props: ActiveScoutCensusProps) {
    const navigate = useNavigate();
    const loc = useLocation();
    const data: ActiveScoutCensusSummaryForm | null = loc.state?.data ?? fillFromCneus(props.census);
    
    const YPSCitizenshipOptions : Option[] = [
        { label: 'Oświadczam, że posiadam wyłącznie obywatelstwo polskie.', value: 'Oświadczam, że posiadam wyłącznie obywatelstwo polskie.' },
        { label: 'Oświadczam, że poza obywatelstwem polskim posiadam również obywatelstwo innego państwa.', value: 'Oświadczam, że poza obywatelstwem polskim posiadam również obywatelstwo innego państwa.' }
    ];
    const [selectedYPSCitizenshipOptions, setSelectedYPSCitizenshipOptions] = useState<Option | undefined>(undefined);

    const YPSResidenceOptions : Option[] = [
        { label: 'Oświadczam, że w ciągu ostatnich 20 lat nie zamieszkiwałam/-łem w innym państwie niż Rzeczpospolita Polska. Jestem świadoma/-y odpowiedzialności karnej za złożenie fałszywego oświadczenia.', value: 'Oświadczam, że w ciągu ostatnich 20 lat nie zamieszkiwałam/-łem w innym państwie niż Rzeczpospolita Polska. Jestem świadoma/-y odpowiedzialności karnej za złożenie fałszywego oświadczenia.' },
        { label: 'Oświadczam, że w ciągu ostatnich 20 lat zamieszkiwałam/łem* w innym państwie niż Rzeczpospolita Polska. Jestem świadoma/-y odpowiedzialności karnej za złożenie fałszywego oświadczenia.', value: 'Oświadczam, że w ciągu ostatnich 20 lat zamieszkiwałam/łem w innym państwie niż Rzeczpospolita Polska. Jestem świadoma/-y odpowiedzialności karnej za złożenie fałszywego oświadczenia.' }
    ];
    const [selectedYPSResidenceOptions, setSelectedYPSResidenceOptions] = useState<Option | undefined>(undefined);
    
    const [signUpError, setSignUpError] = useState<string>("");

    const functionsRef = useRef<MultiFunctionRef>();
    const commentRef = useRef<InputRef>();
    const stateAwardsRef = useRef<InputRef>();
    const citizenshipRef = useRef<InputRef>();
    const residenceRef = useRef<InputRef>();
    const ypsAcceptRef = useRef<InputRef>(null);
    const krkIssueDateRef = useRef<InputRef>();
    const citizenshipExtendedRef = useRef<InputRef>();
    const residenceExtendedRef = useRef<InputRef>();
    const ypsKRKSentRef = useRef<InputRef>(null);

    const functionsRequiresExtendedInfo = ['drużynowy', 'przyboczny', 'inne'];
    const functionsCannotReceiveExtendedInfo = ['hufcowy', 'komendant chorągwi', 'przewodniczący zarządu okręgu', 'przewodniczący KRO', 'członek KRO', 'naczelniczka', 'naczelnik', 'przewodniczący KRZ', 'członek KRZ', 'przewodniczący SH', 'członek SH', 'przewodniczący ZHR']
    
    const handleSubmit = (e: FormEvent) => {
        e.preventDefault();

        if (functionsRef.current?.validate()
            && commentRef.current?.validate()
            && citizenshipRef.current?.validate()
            && residenceRef.current?.validate()
            && ypsAcceptRef.current?.validate()
            && krkIssueDateRef.current?.validate()
            && ypsKRKSentRef.current?.validate()
            && stateAwardsRef.current?.validate()
        ) {
            var ypsCitizenship = selectedYPSCitizenshipOptions?.value ?? '';
            if (selectedYPSCitizenshipOptions?.value == 'Oświadczam, że poza obywatelstwem polskim posiadam również obywatelstwo innego państwa.') {
                if (!citizenshipExtendedRef.current?.validate()) return;
                else ypsCitizenship += " Posiadane obywatelstwa to: " + citizenshipExtendedRef.current?.value();
            }

            var ypsResidence = selectedYPSResidenceOptions?.value ?? '';
            if (selectedYPSResidenceOptions?.value == 'Oświadczam, że w ciągu ostatnich 20 lat zamieszkiwałam/łem w innym państwie niż Rzeczpospolita Polska. Jestem świadoma/-y odpowiedzialności karnej za złożenie fałszywego oświadczenia.') {
                if (!residenceExtendedRef.current?.validate()) return;
                else ypsResidence += " Zamieszkiwane państwa to: " + residenceExtendedRef.current?.value();
            }

            const data = new ActiveScoutCensusSummaryForm({
                comment: commentRef.current?.value() ?? '',
                stateAwards: stateAwardsRef.current?.value() ?? '',
                ypsCitizenship: ypsCitizenship,
                ypsResidence: ypsResidence,
                ypsAccept: ypsAcceptRef.current?.validate(),
                ypsKRKSent: ypsKRKSentRef.current?.validate(),
                krkIssueDate: krkIssueDateRef.current?.value() ?? '',
                assignments: functionsRef.current?.value(),
            })
            navigate("/scout-census/summary/active", { state: { data: data } });
        } else {
            setSignUpError("Wystąpił bład podczas sprawdzenia formularza");
        }
    }; 

    return (
        <form onSubmit={handleSubmit}>
            <MultiFunctionForm  ref={functionsRef as React.Ref<MultiFunctionRef>} functionsCannotReceiveExtendedInfo={functionsCannotReceiveExtendedInfo} functionsRequiresExtendedInfo={functionsRequiresExtendedInfo}/>
            <Heading marginTop={7}
                     as="h4"
                     size="md"
            >
                Ogólne
            </Heading>
            <InputText
                ref={stateAwardsRef}
                label={'Otrzymane odznaczenia państwowe i krzyże honorowe ZHR'}
                initValue={data?.stateAwards ?? ""}
                placeholderText={'wpisz odznaczenia i rok ich uzyskania'}
                isRequired={false}
                rows={3}
                maxLength={500}
            />
            <InputText
                ref={commentRef}
                label={'Uwagi'}
                initValue={data?.comment ?? ""} 
                placeholderText={'miejsce na twoje dodatkowe uwagi'}
                isRequired={false}
                rows={3}
                maxLength={500}
            />
            <Heading marginTop={7}
                     as="h4"
                     size="md"
            >
                Oświadczenia
            </Heading>
            <InputCheckbox 
            ref={ypsAcceptRef} label={"Standardy ochrony małoletnich"} input={
                <>
                    Oświadczam, że zapoznałam/łem się ze{" "}
                    <Link color="teal" href="https://docs.google.com/document/d/10a_IKE9sqaY1I1tA0gdVbsMQw1LFlY5Y/edit#heading=h.gjdgxs" isExternal>
                        „Standardami ochrony małoletnich ZHR”
                    </Link>{" "}
                    i zobowiązuję się do ich przestrzegania.
                </>
            } isRequired={true} initValue={undefined}
            />
            <br/>
            <InputRadioButton
                ref={citizenshipRef}
                label="Obywatelstwo"
                options={YPSCitizenshipOptions}
                isRequired={true}
                initValue={undefined}
                getSelectedOption={setSelectedYPSCitizenshipOptions}
            />
            {selectedYPSCitizenshipOptions?.value == 'Oświadczam, że poza obywatelstwem polskim posiadam również obywatelstwo innego państwa.' &&
                <InputText
                ref={citizenshipExtendedRef}
                label={'Inne obywatelstwa'}
                initValue={''} 
                extraText={'Posiadane obywatelstwa to: '}
                placeholderText={'Podaj jakich państw'}
                isRequired={true}
                maxLength={500}
            />}
            <InputRadioButton
                ref={residenceRef}
                label="Zamieszkanie"
                options={YPSResidenceOptions}
                isRequired={true}
                initValue={undefined}
                getSelectedOption={setSelectedYPSResidenceOptions}
            />
            *zamieszkiwanie nie obejmuje pobytów o charakterze rekreacyjnym, turystycznym, biznesowym lub naukowym, trwających krócej niż 12 miesięcy
            <br/>
            {selectedYPSResidenceOptions?.value == 'Oświadczam, że w ciągu ostatnich 20 lat zamieszkiwałam/łem w innym państwie niż Rzeczpospolita Polska. Jestem świadoma/-y odpowiedzialności karnej za złożenie fałszywego oświadczenia.' &&
                <InputText
                ref={residenceExtendedRef}
                label={'Inne zamieszkiwane państwa'}
                extraText={'Zamieszkiwane państwa to: '}
                initValue={''}
                placeholderText={'Podaj w jakich państwach i w jakich okresach'}
                isRequired={true}
                maxLength={500}
                />}
            <br/>
            data:{data?.krkIssueDate??"" }
            <InputDate
                ref={krkIssueDateRef}
                initValue={data?.krkIssueDate ?? ''}
                label={'Data wystawienia KRK'}
                afterDate="2024-01-01"
                beforeToday={true}
                isRequired={true}
            />
            <br/>
            <InputCheckbox ref={ypsKRKSentRef} label={"Przekazanie KRK"} input={"Oświadczam, że pocztą elektroniczną przekazałam/łem informację z KRK w zakresie wynikającym z art. 21 ust. 3 ustawy z dnia 13 maja 2016 roku o przeciwdziałaniu zagrożeniom przestępczością na tle seksualnym i ochronie małoletnich do dokumentacji Chorągwi lub Okręgu."} isRequired={true} initValue={undefined} />
            <RequiredMark withDescription />
            <ErrorMessage text={signUpError} />
            <ButtonSubmit text="Wyślij prośbę o wpis do rejestracji w bazie instruktorów" />
        </form>
    );
}

function fillFromCneus(census: Census | undefined): ActiveScoutCensusSummaryForm | null {

console.log(census)

    if(!census)
        return null;

    return new ActiveScoutCensusSummaryForm({
        comment: census.RegistrantComment,
        stateAwards:census.StateAwards ?? "",
        ypsCitizenship: census.YPSCitizenship,
        ypsResidence: census.YPSResidence,
        ypsAccept: census.YPSAccept,
        ypsKRKSent: census.YPSKRKSent,
        krkIssueDate: census.KRKIssueDate,
        assignments:[],
    })
}
